import React, { useState, useEffect, useMemo, useCallback } from "react";
import { ListBox } from "primereact/listbox";
import { useNavigate, useLocation } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import "./Sidebar.scss";
import { Sidebar } from "primereact/sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import Property1Dashboard from "../../Assets/Property 1=Dashboard, Property 2=Off (1).png";
import Property1Hamburger from "../../Assets/Property 1=Hamburger.png";
import Property1Masters from "../../Assets/Property 1=Masters, Property 2=Off (1).png";
import Property1Setting from "../../Assets/Property 1=Setting, Property 2=Off.png";
import Property1DashboardActive from "../../Assets/Property 1=Dashboard, Property 2=On.png";
import Property1SetttingsActive from "../../Assets/Property 1=Setting, Property 2=On.png";
import Property1MastersActive from "../../Assets/Property 1=Masters, Property 2=On.png";
import Property1LogoutActive from "../../Assets/Property 1=Logout, Property 2=On (1).png";
import Property1Logout from "../../Assets/Property 1=Logout, Property 2=Off.png";
import Property1Training from "../../Assets/Property 1=Training, Property 2=Off.png";
import Property1TrainingActive from "../../Assets/Property 1=Training, Property 2=On.png";
import Changelanguage from "../../Assets/language.png";
import * as loginSelector from "../../Store/Login/LoginSelector";
import * as profileSelector from "../../Store/Profile/ProfileSelector";
import { fetchProfileData } from "../../Store/Profile/ProfileAction";
import Property1PhcHead from "../../Assets/Property 1=Asha-ANM, Property 2=Off.png";
import Property1PhcHeadActive from "../../Assets/Property 1=Asha-ANM, Property 2=On.png";
import { useLanguage } from "../../Layout/ChangeLanguage/LanguageProvider";

const SideBar = (props) => {
  const { menus } = props;
  const { t } = useTranslation();
  const { selectedLanguageId } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [selectedButton, setSelectedButton] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const userCode = useSelector(loginSelector.getUserCode);
  const navigate = useNavigate();
  const location = useLocation();
  const profileData = useSelector(profileSelector.getProfileInfo);
  const toggleSidebar = () => {
    setVisible(!visible);
  };
  const dispatch = useDispatch();
  const visi = () => {
    setVisible(!visible);
  };

  const handleMouseEnter = (buttonValue) => {
    setHoveredButton(buttonValue);
  };
  const handleMouseLeave = () => {
    setHoveredButton(null);
  };
  const role = sessionStorage.getItem("userRole");
  const sidebarItems = useMemo(() => {
    return menus
      .filter((menu) => menu.hasAccess) // Filter out menus that do not have access
      .map((menu) => {
        let image, activeImage;

        // Determine the images based on menu name (this can be customized)
        switch (menu.menuName) {
          case "dashboard":
            image = Property1Dashboard;
            activeImage = Property1DashboardActive;
            break;
          case "allMasters":
            image = Property1Masters;
            activeImage = Property1MastersActive;
            break;
          case "iecModule":
            image = Property1Training;
            activeImage = Property1TrainingActive;
            break;
          case "anmDetails":
            image = Property1PhcHead;
            activeImage = Property1PhcHeadActive;
            break;
          case "afDetails":
            image = Property1PhcHead;
            activeImage = Property1PhcHeadActive;
            break;
          case "profileSetting":
            image = Property1Setting;
            activeImage = Property1SetttingsActive;
            break;
          case "changeLanguage":
            image = Changelanguage;
            activeImage = Changelanguage;
            break;
          case "logout":
            image = Property1Logout;
            activeImage = Property1LogoutActive;
            break;
          default:
            image = null;
            activeImage = null;
            break;
        }

        return {
          label: t(menu.menuLabel),
          value: menu.route.slice(1), // Removing leading "/" from route
          image,
          activeImage,
        };
      });
  }, [t]);

  const isButtonHighlighted = useCallback(
    (button) => {
      if (
        button.value &&
        location.pathname.includes(`/${button.value.toLowerCase()}`)
      ) {
        return true;
      }
      if (
        button.label &&
        location.pathname.includes(`/${button.label.toLowerCase()}`)
      ) {
        return true;
      }
      if (button.children && Array.isArray(button.children)) {
        return button.children.some((child) => isButtonHighlighted(child));
      }

      return false;
    },
    [location.pathname]
  );

  useEffect(() => {
    const matchingButton = sidebarItems.find((item) => {
      return isButtonHighlighted(item);
      // Or, you can use the implicit return syntax:
      // return isButtonHighlighted(item);
    });
    dispatch(fetchProfileData(selectedLanguageId));
    if (matchingButton) {
      setSelectedButton(matchingButton.value);
    }
  }, [
    location.pathname,
    sidebarItems,
    isButtonHighlighted,
    dispatch,
    selectedLanguageId,
    userCode,
  ]);

  const handleButtonClick = (buttonName, route) => {
    setVisible(false);
    setHoveredButton(null);
    setSelectedButton(buttonName);

    if (buttonName === "logout") {
      // Navigate to the login page
      navigate("/login");
      const keysToRemove = [
        "userToken",
        "userRole",
        "refreshToken",
        "entireToken",
        "phcId",
        "stateName",
        "stateId",
        "areaId",
        "districtId",
        "districtName",
        "talukaId",
        "talukaName",
        "accessMenus",
        "lgbId",
      ];
      keysToRemove.forEach((key) => sessionStorage.removeItem(key));
    } else {
      navigate(route);
    }
  };
  const itemTemplateFun = (option) => (
    <Button
      size="large"
      onMouseEnter={() => handleMouseEnter(option.value)}
      onMouseLeave={() => handleMouseLeave()}
      onClick={() =>
        handleButtonClick(option.value, `/${option.value.toLowerCase()}`)
      }
      className={`sidebar-button  ${
        selectedButton === option.value || hoveredButton === option.value
          ? "active"
          : ""
      }`}
      data-testid={`sidebar-button-${option.value.toLowerCase()}`}
    >
      <div className="flex flex-row flex-wrap">
        <img
          className="flex list-img"
          src={
            selectedButton === option.value || hoveredButton === option.value
              ? option.activeImage
              : option.image
          }
          alt=""
        />
        <div className="flex menu-text  ">{option.label}</div>{" "}
      </div>
    </Button>
  );

  const renderProfilePhoto = () => {
    if (!profileData.profilePhoto) {
      return (
        <Avatar
          label={
            profileData.firstname
              ? profileData.firstname.charAt(0).toUpperCase()
              : ""
          }
          size="xlarge"
          style={{
            backgroundColor: "rgb(222, 226, 230)",
            color: "black",
            marginLeft: "4.5rem",
          }}
          data-testid="avatar-placeholder"
        />
      );
    }

    if (typeof profileData.profilePhoto === "string") {
      return (
        <img
          src={profileData.profilePhoto}
          alt="Selected"
          className="image-style"
          data-testid="profile-photo"
        />
      );
    }
    return (
      <img
        src={URL.createObjectURL(profileData.profilePhoto)}
        alt="Selected"
        className="image-style"
        data-testid="profile-photo"
      />
    );
  };
  const sidebarcontent = () => {
    return (
      <div>
        <div className="z-2">
          <p
            className="font-semibold text-xl text-center"
            style={{ color: "#E03581" }}
            data-testid="sidebar-title"
          >
            {t("nhm")}
          </p>
          <div className="align-items-center justify-content-center">
            {renderProfilePhoto()}
            <h4 className="asha-name text-base font-semibold mt-0">
              {profileData.firstname} {profileData.lastname}
            </h4>
            <h5 className="asha-designation font-normal mb-3 text-sm">
              {role}
            </h5>
          </div>
          <hr className="hr-line" />
        </div>
        <div className="mt-2 overflow-y-auto max-h-25rem z-1">
          <ListBox
            className="sidebar-listbox"
            options={sidebarItems}
            onChange={(e) =>
              handleButtonClick(e.value, `/${e.value.toLowerCase()}`)
            }
            optionLabel="label"
            itemTemplate={itemTemplateFun}
          />{" "}
        </div>
      </div>
    );
  };

  return (
    <div className="fixLayout">
      <div className="inline-flex" data-testid="sidebar">
        <div className="hamburger-wrapper">
          <Button
            className="hamburger-button"
            data-testid="toggleSidebarButton"
            onClick={toggleSidebar}
          >
            <img
              src={Property1Hamburger}
              style={{ width: "30%", height: "40%" }}
              alt="Icon"
            />
          </Button>
          <Sidebar
            className="side"
            visible={visible}
            onHide={visi}
            showCloseIcon={!visible}
            modal={false}
            style={{ boxShadow: "none" }}
          >
            {sidebarcontent()}
          </Sidebar>
        </div>
        <div className="sidebar-wrapper">
          <div className="desktop-sidebar">{sidebarcontent()}</div>
        </div>
      </div>
    </div>
  );
};
export default SideBar;
